module.exports = __webpack_public_path__ + "img/goldcoast-line.5fa9fdb1.svg";